import { ReactElement } from 'react';
import { Flex, Link, Text } from '@backstage/ui';

import { AzurePimActivation, PimResourceType } from './AzurePimActivation';
import { AzureShowAllToggle } from './AzureShowAllToggle';
import { useShowAll } from './useShowAll';

import styles from './AzureCard.module.css';

type AzureResource = {
  id: string;
  name: string;
  overviewUrl: string;
};

type AzureResourceLinksProps = {
  label: string;
  emptyText: string;
  icon: ReactElement;
  resourceType: PimResourceType;
  resources: AzureResource[];
};

export const AzureResourceLinks = ({
  label,
  emptyText,
  icon,
  resourceType,
  resources,
}: AzureResourceLinksProps) => {
  const { visibleItems, canToggle, showAll, toggleShowAll } = useShowAll(resources);

  return (
    <Flex direction="column" gap="1">
      <Text weight="bold" color="secondary" className={styles.label}>
        {label}
      </Text>
      <Flex direction="column" gap="2">
        <Flex align="center" gap="3" className={styles.links}>
          {resources.length === 0 ? (
            <Text color="secondary">{emptyText}</Text>
          ) : (
            <>
              {visibleItems.map(resource => (
                <Link
                  key={resource.id}
                  href={resource.overviewUrl}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.link}
                  standalone
                >
                  {icon}
                  {resource.name}
                </Link>
              ))}
              {canToggle && (
                <AzureShowAllToggle
                  resourceType={resourceType}
                  showAll={showAll}
                  onToggle={toggleShowAll}
                />
              )}
            </>
          )}
        </Flex>
        {resources.length > 0 && <AzurePimActivation resourceType={resourceType} />}
      </Flex>
    </Flex>
  );
};
